import { useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

/**
 * useRoute Hook
 *
 * @returns object containing changeRoute function
 */
const useRoute = (): {
  /**
   * Takes the base url & searchParams and pushes the new route to the history
   * @param searchParams (optional) The search params of the route
   * @param baseUrl (optional) The base url of the route
   */
  changeRoute: (searchParams?: string, baseUrl?: string) => void;
} => {
  const location = useLocation();
  const history = useHistory();

  const { pathname } = location;

  /**
   * Takes the base url & searchParams and pushes the new route to the history
   * @param searchParams (optional) The search params of the route
   * @param baseUrl (optional) The base url of the route
   */
  const changeRoute = useCallback(
    (searchParams?: string, baseUrl?: string) => {
      history.push({
        pathname: baseUrl || pathname,
        search: searchParams,
      });
    },
    [history, pathname]
  );

  return {
    changeRoute,
  };
};

export default useRoute;
